import { events } from "@/mocks/hotData";

export default function EventRank() {
  const featured = events[0];
  const rest = events.slice(1);

  return (
    <section id="event" className="scroll-mt-24 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
            <i className="ri-stackshare-line text-xl"></i>
          </span>
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">事件排行 · 今日大瓜</h2>
            <p className="mt-1 text-sm text-foreground-600">每个事件热度实时变化，标题即梗，点到即得。</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          <article className="relative overflow-hidden rounded-3xl border border-accent-200 bg-accent-50 p-6 md:p-8">
            <div className="flex items-center gap-2">
              <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">今日最热</span>
              <span className="text-xs text-accent-800">{featured.tag} · {featured.time}</span>
            </div>
            <h3 className="mt-5 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              {featured.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{featured.summary}</p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <span className="flex items-center gap-1.5 text-sm font-bold text-primary-600">
                <i className="ri-fire-fill"></i>
                {featured.heat}
                <span className="text-xs font-normal text-foreground-500">热度</span>
              </span>
              <a
                href="#topics"
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                深度看瓜
              </a>
            </div>
            <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-accent-200/40 blur-2xl"></div>
          </article>

          <div className="flex flex-col gap-3">
            {rest.map((ev, i) => (
              <article
                key={ev.title}
                className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-200 md:gap-5 md:p-5"
              >
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-sm font-black text-secondary-800">
                  {i + 2}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">{ev.title}</h3>
                    <span className="whitespace-nowrap text-[11px] text-foreground-400">{ev.time}</span>
                  </div>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{ev.summary}</p>
                  <div className="mt-2 flex items-center gap-2 text-xs text-primary-600">
                    <i className="ri-fire-line"></i>
                    <span>{ev.heat} 热度</span>
                    <span className="text-secondary-800">{ev.tag}</span>
                  </div>
                </div>
                <span className="mt-1 text-foreground-300 transition-colors group-hover:text-primary-500">
                  <i className="ri-arrow-right-up-line text-lg"></i>
                </span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}